<template>
  <v-btn
    :class="[color, 'primary--text rounded-lg']"
    :loading="loading"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'TextButton',
  props: {
    color: { type: String, default: 'secondary' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
}
</script>
